import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Errors extends Vue {
  getApiErrorMessage(type) {
    return this.$t(`${type}`)
  }

  displayErrors(errors) {
    console.log(errors)
    errors.errors.forEach((error) => {
      this.$toast.open({
        type: 'is-danger',
        duration: 5000,
        message: this.getApiErrorMessage(error.type) as string
      })
    })
  }
}

